import React, { useState, useEffect, useRef } from 'react';
import { Layout } from 'antd';
import AdminSidebar from '../components/AdminSidebar';
import AdminHeader from '../components/AdminHeader';
import AdminDashboard from './AdminDashboard';
import Users from './Users';
import LocationManagement from './Locations';
import Reports from './Reports';
import GstFiling from './GstFiling';
import TdsFiling from './TdsFiling';
import GlLedger from './GlLedger';
import PurchaseOrders from './PurchaseOrders';
import Inventory from './Inventory';
import AdminProfile from './AdminProfile';
import { Routes, Route, Navigate } from 'react-router-dom';
import './AdminPortal.css';

const { Content } = Layout;

const AdminPortal: React.FC = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const wasMobileRef = useRef<boolean | null>(null);

  useEffect(() => {
    document.documentElement.classList.remove('admin-login-active', 'user-login-active');
    document.body.style.removeProperty('overflow');
    document.documentElement.style.removeProperty('overflow');
    document.documentElement.style.removeProperty('height');
    document.body.style.removeProperty('height');
  }, []);

  useEffect(() => {
    const checkScreenSize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      // Auto-close only when transitioning from desktop -> mobile.
      if (mobile && wasMobileRef.current === false) {
        setSidebarCollapsed(true);
      }
      wasMobileRef.current = mobile;
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  const handleSidebarCollapse = (collapsed: boolean) => {
    setSidebarCollapsed(collapsed);
  };

  return (
    <Layout className="admin-portal-layout" style={{ height: '100dvh', minHeight: '100dvh', overflow: 'hidden', display: 'flex' }}>
      <AdminSidebar
        collapsed={sidebarCollapsed}
        onCollapse={handleSidebarCollapse}
        isMobile={isMobile}
      />
      <Layout
        className={`admin-portal-content-layout ${isMobile && !sidebarCollapsed ? 'sidebar-drawer-open' : ''}`}
        style={{
          marginLeft: sidebarCollapsed ? (isMobile ? 0 : 80) : (isMobile ? 0 : 280),
          transition: 'margin-left 0.3s ease',
          flex: 1,
          minHeight: 0,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <AdminHeader
          isMobile={isMobile}
          sidebarCollapsed={sidebarCollapsed}
          onOpenSidebar={() => setSidebarCollapsed(prev => !prev)}
        />
        <Content
          className="admin-portal-content main-content-full"
          style={{
            margin: 0,
            padding: 0,
            flex: 1,
            minHeight: 0,
            height: '100%',
            width: '100%',
            position: 'relative',
            zIndex: 0,
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
            background: '#F5F7FA',
          }}
        >
          <div className="main-content-inner admin-portal-scroll">
          <Routes>
            <Route path="" element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="users" element={<Users />} />
            <Route path="users/add" element={<Users />} />
            {/* Employee Overview merged into User Management; redirect old link */}
            <Route path="users/overview" element={<Navigate to="/admin-portal/users" replace />} />
            {/* Backward compatibility: old link redirects to User Management */}
            <Route path="users/privileges" element={<Navigate to="/admin-portal/users" replace />} />
            <Route path="locations" element={<LocationManagement />} />
            <Route path="purchase-orders" element={<PurchaseOrders />} />
            <Route path="inventory" element={<Inventory />} />
            <Route path="reports/sales" element={<Reports />} />
            <Route path="reports/gst" element={<GstFiling />} />
            <Route path="reports/tds" element={<TdsFiling />} />
            <Route path="reports/gl" element={<GlLedger />} />
            <Route path="profile" element={<AdminProfile />} />
          </Routes>
          </div>
        </Content>
      </Layout>
    </Layout>
  );
};

export default AdminPortal;
